import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            关于平台的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {faqData.map((item, idx) => (
              <article
                key={idx}
                className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
              >
                <h3 className="text-sm font-semibold text-foreground-900 mb-3 flex items-start gap-2">
                  <span className="text-primary-500 flex-shrink-0 mt-0.5">
                    <i className="ri-question-answer-line"></i>
                  </span>
                  {item.q}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-6">
                  {item.a}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}